import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EmailRecord } from "@models/email-templates/email-record";

@Component({
  selector: 'app-email-recipients',
  standalone: true,
  templateUrl: './email-recipients.component.html',
  styleUrl: './email-recipients.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailRecipientsComponent {
  @Input() emailRecord!: EmailRecord;
  @Input() showSender = false;
}
